import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/app/(public)/faqs/page.tsx");
